import React from 'react';

import { useIntl } from 'react-intl';

import { AssetsIcon, ConfluenceIcon, JiraIcon, TalentIcon } from '@atlaskit/logo';

import { type PrimaryProductKey, PrimaryProductKeys } from '../../../constants/products';

import { i18n } from './messages';

export const FilterProductIcon = (props: {
	primaryProduct?: PrimaryProductKey;
	showPrimaryProductIcon?: boolean;
}): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const { showPrimaryProductIcon, primaryProduct } = props;

	if (!showPrimaryProductIcon || !primaryProduct) {
		return null;
	}

	if (primaryProduct === PrimaryProductKeys.Confluence) {
		return (
			<ConfluenceIcon
				shouldUseNewLogoDesign
				label={formatMessage(i18n.confluenceIconLabel)}
				size="xxsmall"
			/>
		);
	}

	if (primaryProduct === PrimaryProductKeys.Jira) {
		return (
			<JiraIcon shouldUseNewLogoDesign label={formatMessage(i18n.jiraIconLabel)} size="xxsmall" />
		);
	}
	if (primaryProduct === PrimaryProductKeys.Assets) {
		return (
			<AssetsIcon
				shouldUseNewLogoDesign
				label={formatMessage(i18n.assetsIconLabel)}
				size="xxsmall"
			/>
		);
	}

	if (primaryProduct === PrimaryProductKeys.Talent) {
		return (
			<TalentIcon
				shouldUseNewLogoDesign
				label={formatMessage(i18n.talentIconLabel)}
				size="xxsmall"
			/>
		);
	}

	// Add more primary product icons here

	return null;
};
